import dayjs from 'dayjs';

import { TicketSettingsFormValues } from './types';

import { TicketType } from 'v2/constants';

export const TICKET_SETTINGS_FORM_INITIAL_VALUES: TicketSettingsFormValues = {
  type: TicketType.GOLDEN,
  title: '',
  subtitle: '',
  description: '',
  link: '',
  date: dayjs().add(1, 'day'),
  backgroundImageId: null,
  prizeValue: '',
  details: '',
};
